import { getPreferredLanguage } from '@/locale/util'

const displayNamesByLocale = new Map<string, Intl.DisplayNames>()

/** The country's name in the user's language, looked up from its ISO 3166-1
 * alpha-2 code. Falls back to the given name when the browser has none. */
export function countryName(
  isoCode: string | null | undefined,
  fallback: string,
  locale: string = getPreferredLanguage()
): string {
  if (!isoCode) return fallback
  let displayNames = displayNamesByLocale.get(locale)
  if (!displayNames) {
    displayNames = new Intl.DisplayNames([locale], {
      type: 'region',
      fallback: 'none',
    })
    displayNamesByLocale.set(locale, displayNames)
  }
  try {
    return displayNames.of(isoCode.toUpperCase()) ?? fallback
  } catch {
    return fallback
  }
}
